import { useEffect, useState } from "react";
import type { ProductionQuantityUnitOptions } from "./models";
import { productionGateway } from "./production-gateway";
import { decodeQuantityUnitOptions } from "./quantity-unit-options";

export function useQuantityUnitOptions(runId: string | null, terminalCode: string, refreshKey = "") {
  const [state, setState] = useState<{ runId: string | null; contract: ProductionQuantityUnitOptions | null; loading: boolean; error: string | null }>({ runId: null, contract: null, loading: false, error: null });
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!runId) return;
    const controller = new AbortController();
    setState({ runId, contract: null, loading: true, error: null });
    void productionGateway.quantityUnitOptions(runId, terminalCode, controller.signal)
      .then((value) => {
        if (!controller.signal.aborted) setState({ runId, contract: decodeQuantityUnitOptions(value), loading: false, error: null });
      }).catch((error) => {
        if (!controller.signal.aborted) setState({ runId, contract: null, loading: false, error: error instanceof Error ? error.message : "Ürün birimleri doğrulanamadı." });
      });
    return () => controller.abort();
  }, [runId, terminalCode, refreshKey, attempt]);
  return { ...(state.runId === runId ? state : { contract: null, loading: Boolean(runId), error: null }), retry: () => setAttempt((value) => value + 1) };
}
